import * as React from 'react';
import { SVGProps } from 'react';

const SvgCovid19Mask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path fill={props.fill} d="M26.37 19.96H15.7v3.58h7.35l3.32-3.58Z" />
    <path
      fill="currentColor"
      d="M34.76 24.18v-1.72l-6.57 3.21c.52-1.01.82-2.24.82-3.69 0-3.77-2.76-7.13-5.11-9.29l10.89 3.43-.04-1.64-14.24-4.41-.11-.04-.11.04-14.25 4.41L6 16.12l10.89-3.43c-2.35 2.16-5.11 5.52-5.11 9.29 0 1.45.3 2.69.82 3.69l-6.53-3.21v1.72l9.62 4.7c1.6.9 3.36 1.27 4.7 1.27 1.34 0 3.1-.37 4.7-1.27l9.66-4.7h.01ZM20.4 11.75c1.79 1.31 7.13 5.56 7.13 10.22 0 6.23-6.68 6.64-7.13 6.68-.45-.04-7.13-.41-7.13-6.68 0-4.66 5.33-8.92 7.13-10.22Z"
    />
  </svg>
);

export default SvgCovid19Mask;
